<template>
    <div class="progress-bar-container">
        <div class="container-md">
            <div class="row">
                <div class="col d-flex align-items-center">
                    <div v-if="$slots.header" class="progress-bar-container__text">
                        <slot name="header" />
                    </div>
                    <div v-if="$slots.bar" class="progress-bar-container__bar">
                        <slot name="bar" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
    },
    data() {
        return {

        }
    },
}
</script>